<!--<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
    </div>
    <div class="content-body">
      <section class="flexbox-container">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div class="col-md-4 col-10 box-shadow-2 p-0">
            <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
              <div class="card-header border-0 pb-0">
                <div class="card-title text-center">
                  <img src="assets/images/logo/logo-dark.png" alt="branding logo">
                </div>-->
<!--<h6 class="card-subtitle line-on-side text-muted text-center font-small-3 pt-2">
  <span>Easily Using</span>
</h6>-->
<!--</div>
-->
<!--<app-social-signin></app-social-signin>
<p class="card-subtitle line-on-side text-muted text-center font-small-3 mx-2 my-1">
  <span>OR Using Email</span>
</p>-->
<!--<div class="card-content">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">-->
<!--<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
    </div>
    <div class="content-body">
      <section class="flexbox-container">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div class="col-md-4 col-10 box-shadow-2 p-0">
            <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
              <div class="card-title text-center">
                <img src="assets/custom/images/abg/abglogo512.png" alt="branding logo">
              </div>
              <div class="card-content">
                <div class="card-body">-->
<!--<div class="card-header">Forget Password</div>-->
<!--<div class="card-body">
                    <form [formGroup]="forgetPasswordForm" (ngSubmit)="onSubmit()">
                      <div class="form-group">
                        <label for="email">Email address</label>
                        <input type="email" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                          <div *ngIf="f.email.errors.required">Email is required</div>
                          <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                        </div>
                      </div>
                      <button type="submit" class="btn btn-primary">Send Reset Link</button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>-->
<!--</div>
      </div>
    </div>
  </div>
</div>-->
<!--</div>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</div>-->
<!-- ═══════════════════════════════════════════════════════════════
     FORGOT PASSWORD — request a reset (NEW feature).
     Shares the auth shell. Bindings match forgotpassword.component.ts.
═══════════════════════════════════════════════════════════════ -->
<!--<div class="auth-shell">

  <aside class="auth-brand">
    <div class="auth-brand-logo">
      <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
      <span>KG Technologys</span>
    </div>
    <h1 class="auth-brand-headline">Forgot your password?</h1>
    <p class="auth-brand-sub">No problem. Enter your registered email and we'll send you a secure link to reset it.</p>
    <ul class="auth-brand-features">
      <li><i class="la la-envelope"></i> Reset link sent to your email</li>
      <li><i class="la la-shield"></i> Link expires for your security</li>
      <li><i class="la la-clock-o"></i> Back in, in under a minute</li>
    </ul>
    <div class="auth-brand-footer">© KG Technologys. All rights reserved.</div>
  </aside>

  <main class="auth-main">
    <div class="auth-card">
      <div class="auth-mobile-logo">
        <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
      </div>-->
<!-- Request form -->
<!--<form [formGroup]="forgotForm" (ngSubmit)="submit()" *ngIf="!sent" novalidate>
  <h2 class="auth-title">Reset password</h2>
  <p class="auth-sub">Enter the email linked to your account.</p>

  <div class="auth-banner auth-banner--error" *ngIf="errorMessage">
    <i class="la la-exclamation-circle"></i> <span>{{ errorMessage }}</span>
  </div>

  <div class="auth-field">
    <label class="auth-label">Email address</label>
    <div class="auth-input-wrap">
      <input type="email" class="auth-input" formControlName="email" placeholder="you@example.com"
             [ngClass]="{ 'is-invalid': submitted && ff.email.errors }" />
      <i class="auth-input-icon la la-envelope"></i>
    </div>
    <div class="auth-error" *ngIf="submitted && ff.email.errors?.required">Email is required</div>
    <div class="auth-error" *ngIf="submitted && ff.email.errors?.email">Enter a valid email</div>
  </div>

  <button type="submit" class="auth-btn auth-btn-primary" [disabled]="loading">
    <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
    <span>{{ loading ? 'Sending…' : 'Send reset link' }}</span>
  </button>

  <p class="auth-foot"><a [routerLink]="['/login']" class="auth-link">&larr; Back to sign in</a></p>
</form>-->
<!-- Success state -->
<!--<div *ngIf="sent" style="text-align:center;">
        <div class="auth-product-icon auth-pi--hrm" style="width:64px;height:64px;font-size:30px;margin:0 auto var(--space-4);">
          <i class="la la-check"></i>
        </div>
        <h2 class="auth-title">Check your inbox</h2>
        <p class="auth-sub">We've sent a password reset link to <strong>{{ forgotForm.value.email }}</strong>. It expires shortly, so use it soon.</p>
        <button type="button" class="auth-btn auth-btn-secondary" (click)="submit()" [disabled]="loading">Resend link</button>
        <p class="auth-foot"><a [routerLink]="['/login']" class="auth-link">Back to sign in</a></p>
      </div>
    </div>
  </main>
</div>-->


<div class="fp-wrap">
  <div class="fp-card">
    <h1 class="fp-title">Reset your password</h1>
    <p class="fp-sub" *ngIf="step === 1">Enter your account email and we'll send you a reset code.</p>
    <p class="fp-sub" *ngIf="step === 2">Enter the code we sent you and choose a new password.</p>

    <div *ngIf="errorMessage" class="fp-alert fp-alert--error" role="alert">{{ errorMessage }}</div>
    <div *ngIf="successMessage" class="fp-alert fp-alert--ok" role="status">{{ successMessage }}</div>

    <!-- Step 1: request a reset code -->
    <form *ngIf="step === 1" [formGroup]="requestForm" (ngSubmit)="requestCode()" novalidate>
      <div class="fp-field">
        <label for="fp-email">Email</label>
        <input id="fp-email"
               type="email"
               formControlName="email"
               class="fp-input"
               [class.fp-input--invalid]="rf.email.touched && rf.email.errors"
               placeholder="you@example.com"
               autocomplete="email" />
        <div class="fp-error" *ngIf="rf.email.touched && rf.email.errors">
          <span *ngIf="rf.email.errors.required">Email is required.</span>
          <span *ngIf="!rf.email.errors.required && rf.email.errors.email">Enter a valid email address.</span>
        </div>
      </div>

      <button type="submit" class="fp-btn fp-btn--primary" [disabled]="loading">
        {{ loading ? 'Sending…' : 'Send reset code' }}
      </button>

      <a [routerLink]="['/login']" class="fp-back-link">Back to sign in</a>
    </form>

    <!-- Step 2: enter code + new password -->
    <form *ngIf="step === 2" [formGroup]="resetForm" (ngSubmit)="resetPassword()" novalidate>
      <div class="fp-field">
        <label for="fp-code">Reset code</label>
        <input id="fp-code"
               type="text"
               formControlName="code"
               class="fp-input"
               [class.fp-input--invalid]="sf.code.touched && sf.code.errors"
               placeholder="Enter the code from your email"
               autocomplete="one-time-code" />
        <div class="fp-error" *ngIf="sf.code.touched && sf.code.errors">
          <span *ngIf="sf.code.errors.required">Reset code is required.</span>
        </div>
      </div>

      <div class="fp-field">
        <label for="fp-new-password">New password</label>
        <input id="fp-new-password"
               type="password"
               formControlName="newPassword"
               class="fp-input"
               [class.fp-input--invalid]="sf.newPassword.touched && sf.newPassword.errors"
               placeholder="At least 8 characters"
               autocomplete="new-password" />
        <div class="fp-error" *ngIf="sf.newPassword.touched && sf.newPassword.errors">
          <span *ngIf="sf.newPassword.errors.required">New password is required.</span>
          <span *ngIf="!sf.newPassword.errors.required && sf.newPassword.errors.minlength">Password must be at least 8 characters.</span>
        </div>
      </div>

      <button type="submit" class="fp-btn fp-btn--primary" [disabled]="loading">
        {{ loading ? 'Updating…' : 'Update password' }}
      </button>

      <button type="button" class="fp-btn fp-btn--link" (click)="backToRequest()" [disabled]="loading">
        Use a different email / resend code
      </button>
    </form>
  </div>
</div>

